export const DataType = {
  STR: 'STRING',
  INT: 'INT',
  FLOAT: 'FLOAT',
  BOOL: 'BOOLEAN',
  DATETIME: 'DATETIME',
  DATE: 'DATE',
  STR_WITHOUT_LIKE: 'STRING_WITHOUT_LIKE',
  STR_EQUAL_ONLY: 'STRING_EQUAL_ONLY',
  STR_IN: 'STRING_IN',
  INT_COMPLETE: 'INT_COMPLETE'
}
